import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import DoubleTragusPiercingImage from '../../Assets/Piercing Services/Double tragus piercing.jpg';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function DoubleTragusPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Double Tragus Piercing UAE | 250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Double Tragus Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Double Tragus Piercing 250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={DoubleTragusPiercingImage} alt="Double Tragus Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Double Tragus Piercing</h3>

          <p>
            Elevate your ear styling with our professional double tragus piercing services in the UAE, available at an affordable price of 250 AED. Double tragus piercing is a bold and modern trend that features two piercings on the tragus—the small cartilage located in front of the ear canal—creating a layered and eye-catching look. Perfect for those who want to stand out with a unique and stylish ear design, this piercing option adds depth and dimension to your overall appearance. Whether you prefer minimal studs or a combination of elegant jewelry pieces, our expert specialists ensure precise placement for a balanced and aesthetically pleasing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each double tragus piercing with accuracy and care. We follow strict hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Our goal is to provide a quick, efficient, and pain-minimized procedure so you can enjoy your new piercing with confidence.
          </p>

          <p>
            Double tragus piercing is ideal for individuals who want to take their ear styling to the next level with a bold and layered look. It pairs beautifully with other ear piercings such as lobe, helix, or conch, allowing you to create a curated ear design that reflects your personal style. Our specialists take the time to understand your preferences and guide you in choosing the best placement and jewelry combinations to achieve the desired look.
          </p>

          <p>
            The procedure is typically completed within a short time, even with two piercings, making it a convenient option for those with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring a comfortable experience throughout the process. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensure a smooth healing journey.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and well cared for. We understand that cartilage piercings can feel intimidating, especially when getting multiple piercings at once, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and comfortable experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your double tragus piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. Proper aftercare ensures effective healing and helps maintain the beauty and longevity of your piercing.
          </p>

          <p>
            Our double tragus piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted double tragus piercing services in the UAE for a safe, stylish, and professional experience. With experienced specialists, precise techniques, and a commitment to customer satisfaction, we help you achieve a bold and layered ear look effortlessly. Book your double tragus piercing appointment today and redefine your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Double Tragus Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default DoubleTragusPiercing;